/**
 * @fileoverview controller for HIPAA DeIdentified Review Settings
 *
 * @author Saurav Lohani slohani@yext.com
 */
goog.module('yext.storm.DeIdentifiedReviewSettingsView');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const IndividualComplianceSettingView = goog.require('yext.storm.IndividualComplianceSettingView');
const routes = goog.require('yext.storm.routes');

/**
 * @constructor
 * @extends {IndividualComplianceSettingView}
 */
const DeIdentifiedReviewSettingsView = function() {
  /** @type {!jQuery} */
  this.$el = $('.js-de-identified-review-settings-field');

  IndividualComplianceSettingView.call(this);
};
goog.inherits(DeIdentifiedReviewSettingsView, IndividualComplianceSettingView);

/** @enum */
DeIdentifiedReviewSettingsView.Mode = {
  REPLACE: 0,
  REMOVE: 1,
};

/** @override */
DeIdentifiedReviewSettingsView.prototype.doAdditionalBinding = function() {
  this.bindInputToModel_();
  this.resetInput();
};


/** @override */
DeIdentifiedReviewSettingsView.prototype.getAdditionalModelProperties = function() {
  return {
    'selectedOption': this.$el.data('option'),
  };
};

/** @override */
DeIdentifiedReviewSettingsView.prototype.resetInput = function() {
  let remove = this.model.get('selectedOption') ==
    DeIdentifiedReviewSettingsView.Mode.REMOVE;
  document.getElementById('replace').checked = !remove;
  document.getElementById('remove').checked = remove;
};

/** @override */
DeIdentifiedReviewSettingsView.prototype.getSubmitUrl = function() {
  return routes.AccountSettings.updateDeIdentifiedReviewSettings();
};

/** @override */
DeIdentifiedReviewSettingsView.prototype.getData = function() {
  return {'selectedOptionOrdinal': this.model.get('selectedOption')};
};

/** @private */
DeIdentifiedReviewSettingsView.prototype.bindInputToModel_ = function() {
  this.$el.find('.js-setting-option').inputchange(function(e) {
    let selectedOption = this.$el.find('.js-setting-option:checked').val();
    this.model.set('selectedOption', selectedOption);
  }.bind(this));
};

/** @override */
DeIdentifiedReviewSettingsView.prototype.renderDisplay = function() {
  let option = this.model.get('selectedOption');

  if (option == DeIdentifiedReviewSettingsView.Mode.REPLACE) {
    this.$viewMode.html(yext.msg('Replace PHI in reviews with "[omitted]"'));
  } else if (option = DeIdentifiedReviewSettingsView.Mode.REMOVE) {
    this.$viewMode.html(yext.msg('Remove reviews with PHI entirely'));
  }
};

exports = DeIdentifiedReviewSettingsView;
